$(document).ready(function() {

	$(function () {
		$('[data-toggle="tooltip"]').tooltip()
	});

	$(".scroll_content").width($(".overview_table").width() + 300);

	$(".scroll_div").on('scroll', function(){
		//var pos = $(".scroll_div").scrollLeft() / $(".scroll_div").width() * $(".overview_wrapper").width();	
		$(".scroll_content").width($(".overview_table").width() + 300);
		$(".overview_wrapper").scrollLeft($(".scroll_div").scrollLeft());
	});
	$(".overview_wrapper").on('scroll', function(){
		//var pos = $(".overview_wrapper").scrollLeft() / $(".overview_wrapper").width() * $(".scroll_div").width();	
		$(".scroll_div").scrollLeft($(".overview_wrapper").scrollLeft());
	});

	$(window).on('scroll', function() {
		$('.action-bar').css(
      		$(window).scrollTop() > 103
        		? { 'position': 'fixed', 'top': '10px', 'right': '20px' }
        		: { 'position': 'relative', 'top': 'auto', 'right': 'auto' }
    	);
	});

	if($('.scrollToMonth').length) {
		$('.overview_wrapper').scrollLeft($('.scrollToMonth').position().left);
	}
	

	var lastScrollMonth = 0;
	$('.request_button').click(function() {
		var months = $(this).attr('months').split(",");
		if(months.length == 0) return;
		var found = false;
		for(var m in months) {
			if(found == true) {
				$('.overview_wrapper').scrollLeft($('#month'+months[m]).position().left);
				lastScrollMonth = months[m];
				return;
			}
			if(months[m] == lastScrollMonth) {
				found = true;
			}
		}
		$('.overview_wrapper').scrollLeft($('#month'+months[0]).position().left);
		lastScrollMonth = months[0];
	});

	var lastScrollMonthKrank = 0;
	$('.krank_button').click(function() {
		var months = $(this).attr('months').split(",");
		if(months.length == 0) return;
		var found = false;
		for(var m in months) {
			if(found == true) {
				$('.overview_wrapper').scrollLeft($('#month'+months[m]).position().left);
				lastScrollMonthKrank = months[m];
				return;
			}
			if(months[m] == lastScrollMonthKrank) {
				found = true;
			}
		}
		$('.overview_wrapper').scrollLeft($('#month'+months[0]).position().left);
		lastScrollMonthKrank = months[0];
	});

	var lastScrollMonthUnapprovedPastVacation = 0;
	$('.unapproved_past_vacation_button').click(function() {
		var months = $(this).attr('months').split(",");
		if(months.length == 0) return;
		var found = false;
		for(var m in months) {
			if(found == true) {
				$('.overview_wrapper').scrollLeft($('#month'+months[m]).position().left);
				lastScrollMonthUnapprovedPastVacation = months[m];
				return;
			}
			if(months[m] == lastScrollMonthUnapprovedPastVacation) {
				found = true;
			}
		}
		$('.overview_wrapper').scrollLeft($('#month'+months[0]).position().left);
		lastScrollMonthUnapprovedPastVacation = months[0];
	});

	function calcMonthSums() {
		var u = 0;
		var fza = 0;
		var ue = 0;
		var k = 0;

		$(".hour_input").each(function() {
			if(parseFloat($(this).val()) > 0) {
				if($(this).hasClass("freizeitausgleich_input")) fza += parseFloat($(this).val());
				if($(this).hasClass("urlaub_input")) u += parseFloat($(this).val());
				if($(this).hasClass("ueberstunden_input")) ue += parseFloat($(this).val());
				if($(this).hasClass("krank_input")) k += parseFloat($(this).val());
			}	
		});

		$("#freizeitausgleich_monat").text(fza);
		$("#urlaub_monat").text(u);
		$("#ueberstunden_monat").text(ue);
		$("#krank_monat").text(k);

	}

	function calcYearSums() {
		var a = parseFloat($("#progress_angefragt").attr("sum"));
		var g = parseFloat($("#progress_genehmigt").attr("sum"));
		var r = parseFloat($("#progress_ruecksprache").attr("sum"));
		var sum = 0;
		var j = parseFloat($("#progress_rest").attr("sum"));
		var ura = parseFloat($("#progress_urlaubsauszahlung").attr("sum"));

		var u = 0;
		var fza = parseFloat($("#progress_fza").attr("sum"));
		var fzafj = parseFloat($("#progress_fza_fj").attr("sum"));
		var ue = parseFloat($("#progress_overtime").attr("sum"));
		var k = 0;
		var ua = parseFloat($("#progress_auszahlung").attr("sum"));


		var ott = parseFloat($("#progress_overtime_transferred").attr("sum"));


		$(".hour_input").each(function() {
			var value = $(this).val().replace(",",".");

			var attr = $(this).attr('val');
			if (typeof attr !== 'undefined' && attr !== false && attr > 0) {
				value = attr.replace(",",".");
			}
			if(parseFloat(value) > 0) {
				if($(this).hasClass('urlaub_input')) {
					u += parseFloat(value);

					if($(this).hasClass("bg-gradient-success")) g += parseFloat(value);
					else if($(this).hasClass("bg-gradient-warning")) r += parseFloat(value);
					else if($(this).hasClass("bg-gradient-danger")) {}
					else a += parseFloat(value);
				} else {
					if($(this).hasClass("freizeitausgleich_input")) fza += parseFloat(value);
					if($(this).hasClass("ueberstunden_input")) ue += parseFloat(value);
					if($(this).hasClass("krank_input")) k += parseFloat(value);
					if($(this).hasClass("ueberstundenauszahlung_input")) ua += parseFloat(value);
				
				}	
			}
		});

		/*$("#angefragt_jahr").text(a);
		$("#genehmigt_jahr").text(g);
		$("#ruecksprache_jahr").text(r);
		$("#summe_jahr").text(a+g+r);
		$("#gesamt_jahr").text(j);
		$("#uebrig_jahr").text(j-a-g-r);*/

		$("#freizeitausgleich_monat").text(fza);
		$("#urlaub_monat").text(u);
		$("#ueberstunden_monat").text(ue);
		$("#krank_monat").text(k);

		$("#krank_jahr").text(parseFloat($("#krank_jahr").attr("sum")) + parseFloat($("#krank_monat").text()));
		$("#freizeitausgleich_jahr").text(parseFloat($("#freizeitausgleich_jahr").attr("sum")) + parseFloat($("#freizeitausgleich_monat").text()));
		$("#ueberstunden_jahr").text(parseFloat($("#ueberstunden_jahr").attr("sum")) + parseFloat($("#ueberstunden_monat").text()));

		$("#progress_overtime_transferred").text(ott);
		$("#progress_overtime_transferred").css('width', ott/(ott+ue)*100+"%");

		$("#progress_overtime").text(ue);
		$("#progress_overtime").css('width', ue/(ott+ue)*100+"%");

		$("#overtime_hours_sum").text(ott+ue);

		$("#progress_fza").text(fza);
		$("#progress_fza").css('width', fza/(ott+ue)*100+"%");

		$("#progress_fza_fj").text(fzafj);
		$("#progress_fza_fj").css('width', fzafj/(ott+ue)*100+"%");

		$("#progress_auszahlung").text(ua);
		$("#progress_auszahlung").css('width', ua/(ott+ue)*100+"%");

		$("#progress_overtime_rest").text(ott+ue-fza-fzafj-ua);
		$("#overtime_hours_rest").text(ott+ue-fza-ua);
		$("#overtime_hours_rest_sum").text(ott+ue-fza-fzafj-ua);
		$("#progress_overtime_rest").css('width', (ott+ue-fza-fzafj-ua)/(ott+ue)*100+"%");


		$("#progress_angefragt").text(a);
		$("#progress_angefragt").css('width', a/j*100+"%");

		$("#progress_genehmigt").text(g);
		$("#progress_genehmigt").css('width', g/j*100+"%");

		$("#progress_ruecksprache").text(r);
		$("#progress_ruecksprache").css('width', r/j*100+"%");

		$("#progress_urlaubsauszahlung").text(ura);
		$("#progress_urlaubsauszahlung").css('width', ura/j*100+"%");

		$("#progress_rest").text(j-a-g-r-ura);
		$("#hours_rest").text(j-a-g-r-ura);
		$("#progress_rest").css('width', (j-a-g-r-ura)/j*100+"%");

	}

	$('#calendar_form').on('submit', function(e){

		// 0.5h Vielfache
		$(".hour_input").each(function() {
			var value = $(this).val().replace(",",".");
			if(parseFloat(value) > 0) {
				if(parseFloat(value) % 0.5 != 0) {
					alert("Es dürfen nur Vielfache von 0,5 Stunden eingetragen werden.");
					e.preventDefault();
					return false;
				}
			}
			
		});

		var isAdminForUser = parseInt($(this).data('is-admin-for-user')) === 1;

		// Freizeitausgleich
		var fzamonth = 0;
		$(".hour_input").each(function() {
			var value = $(this).val().replace(",",".");
			if(parseFloat(value) > 0) {
				if($(this).hasClass('urlaub_input')) {
				} else {
					if($(this).hasClass("freizeitausgleich_input") && parseInt($(this).data('accepted')) !== 1) fzamonth += parseFloat(value);
				}	
			}
		});

		var fzapermonth = $(this).attr('fza');

		if(!isAdminForUser && fzapermonth > 0 && fzamonth > fzapermonth) {
			alert("Der Freizeitausgleich darf "+fzapermonth+" Stunden pro Monat nicht überschreiten.");
			e.preventDefault();
			return false;
		}

		// Homeoffice: gegen die zuletzt vom Server gelieferte Bewertung prüfen.
		var hourRuleViolation = null;
		$('.homeoffice_input').each(function() {
			if(!$(this).is(':checked')) return;
			var rule = ((window.hourRules || {})['homeoffice'] || {})[$(this).data('date')];
			if(rule && !rule.allowed) {
				hourRuleViolation = rule.reason;
				return false;
			}
		});

		if(hourRuleViolation) {
			alert(hourRuleViolation);
			e.preventDefault();
			return false;
		}

		return true;
	    
	});

	//calcMonthSums();
	calcYearSums();

	$(document).on('change keyup', '.hour_input', function(event) {
	    //calcMonthSums();
	    calcYearSums();
	});

	// Regelprüfung: die Entscheidung kommt ausschließlich vom Server aus
	// app/HourRules/. Das Frontend spiegelt sie nur, damit beide Seiten nicht
	// auseinanderlaufen können.
	var hourRuleTypes = ['homeoffice', 'urlaub', 'freizeitausgleich', 'krank'];
	var hourRuleRefreshTimer = null;

	// Liest den aktuellen Formularstand als { typ: { datum: stunden } }.
	function collectHourSelection() {
		var selection = {};
		hourRuleTypes.forEach(function(type) { selection[type] = {}; });

		$('.hour_input').each(function() {
			var $input = $(this);
			var date = $input.data('date');
			if(!date) return;

			var type = null;
			hourRuleTypes.forEach(function(t) {
				if($input.hasClass(t + '_input')) type = t;
			});
			if(!type) return;

			var value;
			if($input.attr('type') === 'checkbox') {
				value = $input.is(':checked') ? 1 : 0;
			} else {
				value = parseFloat(String($input.val()).replace(',', '.')) || 0;
			}

			selection[type][date] = value;
		});

		return selection;
	}

	// Überträgt das Serverergebnis auf die Eingabefelder.
	function applyHourRules() {
		$('.homeoffice_input').each(function() {
			var $input = $(this);
			var date = $input.data('date');
			if(!date) return;

			var rule = ((window.hourRules || {})['homeoffice'] || {})[date];
			if(!rule) return;

			if(rule.allowed) {
				$input.prop('disabled', false).removeAttr('title');
				return;
			}

			// Ein bereits gesetzter Tag bleibt bedienbar, sonst ließe er sich
			// nicht mehr entfernen.
			if($input.is(':checked')) {
				$input.prop('disabled', false).attr('title', rule.reason);
			} else {
				$input.prop('disabled', true).attr('title', rule.reason);
			}
		});
	}

	// Holt die Bewertung für den aktuellen Formularstand nach.
	function refreshHourRules() {
		var $form = $('#calendar_form');
		if($form.length === 0) return;

		clearTimeout(hourRuleRefreshTimer);
		hourRuleRefreshTimer = setTimeout(function() {
			$.post('/calendar/rules', {
				'_token': $('meta[name="csrf-token"]').attr('content'),
				'user_id': $form.attr('user'),
				'year': $form.find('input[name="year"]').val(),
				'month': $form.find('input[name="month"]').val(),
				'types': ['homeoffice'],
				'selection': collectHourSelection()
			}).done(function(response) {
				if(!response || response.ack !== 'success') return;
				window.hourRules = response.rules;
				applyHourRules();
			});
		}, 150);
	}

	$(document).on('change keyup', '.homeoffice_input, .urlaub_input', function() {
		refreshHourRules();
	});

	var button_mode = 1;

	$(".button_mode").change(function() {
		console.log($(this).val());
		button_mode = $(this).val();
	});

	$(".mode_changeable").click(function() {
		changeColor($(this), 'urlaub');
	});

	$(".mode_changeable").on("mousedown mouseover", function (e) {
	    if (e.buttons == 1 || e.buttons == 3) {
	        changeColor($(this), 'urlaub');
	    }
	});

	$(".mode_changeable_krank").click(function() {
		if(button_mode == 0 || button_mode == 1) {
			changeColor($(this), 'krank');
		}
	});

	$(".mode_changeable_krank").on("mousedown mouseover", function (e) {
	    if (e.buttons == 1 || e.buttons == 3) {
	    	if(button_mode == 0 || button_mode == 1) {
	        	changeColor($(this), 'krank');
	    	}
	    }
	});

	$(".mode_changeable_kindkrank").click(function() {
		if(button_mode == 0 || button_mode == 1) {
			changeColor($(this), 'kindkrank');
		}
	});

	$(".mode_changeable_kindkrank").on("mousedown mouseover", function (e) {
	    if (e.buttons == 1 || e.buttons == 3) {
	    	if(button_mode == 0 || button_mode == 1) {
	        	changeColor($(this), 'kindkrank');
	    	}
	    }
	});

	function applyColorChange(el, accepted) {
		el.removeClass("text-light");
		el.removeClass("text-secondary");
		el.removeClass("text-warning");
		el.removeClass("text-danger");
		el.removeClass("text-success");
		el.removeClass("text-shadow");

		if(accepted == 1) {
			el.addClass("text-success");
			if(el.hasClass("bg-gradient-info")) el.addClass("text-shadow");
			if(el.hasClass("bg-gradient-primary")) el.addClass("text-shadow");
		}
		if(accepted == 2) {
			if(el.hasClass("bg-gradient-secondary")) el.addClass("text-warning");
		}
		if(accepted == 3) el.addClass("text-danger");
		if(accepted == 0) {
			if(el.hasClass("bg-gradient-secondary")) el.addClass("text-light");
			if(el.hasClass("bg-gradient-info")) el.addClass("text-light");
			if(el.hasClass("bg-gradient-primary")) el.addClass("text-light");
		}
	}

	function changeColor(el, type) {

		if(el.attr("user") > 0 && el.attr("date") != "") {

			var postData = { 'user': el.attr("user"), 'date': el.attr("date"), 'accepted': button_mode, 'type': type, '_token': $('meta[name="csrf-token"]').attr('content') };

			$.post("/hour", postData, function(res) {

				if(res.ack == "warning") {
					if(confirm("Der Resturlaub würde dadurch unter 0 fallen. Trotzdem genehmigen?")) {
						postData.force = 1;
						$.post("/hour", postData, function(res2) {
							if(res2.ack == "success") {
								applyColorChange(el, res2.accepted);
							}
						});
					}
				} else if(res.ack == "success") {
					applyColorChange(el, res.accepted);
				}

				
			});
			

		}
	}


	$('#daterange').daterangepicker({
		"autoApply": true,
		"maxSpan": {
			"days": 7
		},
		"alwaysShowCalendars": true,
		"startDate": moment($('#datefrom').val(), "YYYY-MM-DD"),
		"endDate": moment($('#dateto').val(), "YYYY-MM-DD"),
		"minDate": moment(),
		"opens": "center",
		"locale": {
	    	"format": 'DD.M.YYYY',
	    	"daysOfWeek": [
	            "So",
	            "Mo",
	            "Di",
	            "Mi",
	            "Do",
	            "Fr",
	            "Sa"
	        ],
	        "monthNames": [
	            "Januar",
	            "Februar",
	            "März",
	            "April",
	            "Mai",
	            "Juni",
	            "Juli",
	            "August",
	            "September",
	            "Oktober",
	            "November",
	            "Dezember"
	        ],
	        "firstDay": 1
	    }
	}, function(start, end, label) {
		$('#datefrom').val(start.format('YYYY-MM-DD'));
		$('#dateto').val(end.format('YYYY-MM-DD'));
		console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
	});


});